/** Ultrasound workflow layout — fields use nurse textarea/input for reliable editing. */
export const rad = {
  stepPanel:
    'rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-6',
  stepPanelImaging: 'border-l-4 border-l-violet-500',
  stepPanelReport: 'border-l-4 border-l-indigo-600',
  stepHeader: 'mb-5 flex items-start gap-3 border-b border-slate-100 pb-4',
  stepBadge:
    'flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-violet-600 text-sm font-bold text-white',
  stepBadgeReport: 'bg-indigo-600',
  stepTitle: 'text-base font-bold text-slate-900',
  stepSubtitle: 'mt-1 text-sm leading-relaxed text-slate-600',
  fieldStack: 'flex flex-col gap-6',
  fieldHint: 'mb-2 text-xs leading-relaxed text-slate-500',
  submitWrap:
    'mt-8 flex flex-col gap-4 border-t border-slate-200 pt-6 sm:flex-row sm:items-center sm:justify-between',
  submitHint: 'text-sm leading-relaxed text-slate-600 max-w-md',
  submitBtn:
    'inline-flex min-h-[3rem] shrink-0 items-center justify-center gap-2 rounded-xl bg-violet-600 px-6 text-sm font-semibold text-white shadow-sm transition hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60',
};
